/* eslint-disable max-len */

import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

function DownloadIcon(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon width="24" height="25" viewBox="0 0 24 25" fill="none" aria-label="download" {...props}>
      <path
        d="M19 12.5V19.5H5V12.5H3V19.5C3 20.6 3.9 21.5 5 21.5H19C20.1 21.5 21 20.6 21 19.5V12.5H19ZM13 13.17L15.59 10.59L17 12L12 17L7 12L8.41 10.59L11 13.17V3.5H13V13.17Z"
        fill="black"
        fillOpacity="0.54"
      />
    </SvgIcon>
  );
}

export default DownloadIcon;
